import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import { Box, Typography } from '@mui/material';
import { PasswordRequirement } from '../../../utils/helpers/passwordValidation';

interface PasswordRequirementsChecklistProps {
  requirements: PasswordRequirement[];
}

export default function PasswordRequirementsChecklist({
  requirements,
}: PasswordRequirementsChecklistProps) {
  if (requirements.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        mt: -1,
        px: 1.5,
        py: 1.25,
        borderRadius: 1,
        backgroundColor: 'grey.50',
        border: '1px solid',
        borderColor: 'grey.200',
      }}
    >
      <Typography
        variant="body2"
        sx={{ fontWeight: 500, color: 'text.primary', mb: 1, fontSize: '0.875rem' }}
      >
        Password must include
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
        {requirements.map(requirement => (
          <Box
            key={requirement.id}
            sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
          >
            {requirement.met ? (
              <CheckCircleIcon sx={{ fontSize: '1rem', color: 'success.main' }} />
            ) : (
              <CircleOutlinedIcon sx={{ fontSize: '1rem', color: 'text.disabled' }} />
            )}
            <Typography variant="body2" sx={{ fontSize: '0.875rem', color: '#666' }}>
              {requirement.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
